/**
 * Converts a camel case string to a snake case string.
 * @example
 * CamelOrPascalToSnakeCase<'rentInspection'> // 'rent_inspection'
 * CamelOrPascalToSnakeCase<'rentInspectionReturn'> // 'rent_inspection_return'
 * CamelOrPascalToSnakeCase<'RentInspectionReturn'> // 'rent_inspection_return'
 */
type CamelCaseToSnakeCaseNonFirst<S extends string> = S extends `${infer T}${infer U}`
  ? T extends Lowercase<T>
    ? `${T}${CamelCaseToSnakeCaseNonFirst<U>}`
    : T extends Uppercase<T>
      ? `_${Lowercase<T>}${CamelCaseToSnakeCaseNonFirst<U>}`
      : `${T}${CamelCaseToSnakeCaseNonFirst<U>}`
  : S;

export type CamelOrPascalToSnakeCase<S extends string> = string extends S
  ? string
  : S extends `${infer T}${infer U}`
    ? `${Lowercase<T>}${CamelCaseToSnakeCaseNonFirst<U>}`
    : S;
